import React, { FlatList, StyleSheet, View } from 'react-native';
import PropTypes from 'prop-types';
import { MODERN_LAYOUT_COLLAPSE_WIDTH } from '../../contexts/Layout';

const GridItem = props => {
    return <View style={[StyleSheet.flatten(Styles.itemContainer), props.children?.props?.eventGridPlaceholder ? { display: 'none' } : {}]}>{props.children}</View>;
};

export const Grid = ({ id, items, nodeTypeAlias, width }) => {
    const collapsed = width <= MODERN_LAYOUT_COLLAPSE_WIDTH;

    if (!items) {
        console.error('cannot display grid without items');
        return null;
    }

    // todo: write test(s) that account for eventGridLastItem when items.length is odd @jacksonkr_
    if (items.length % 2 !== 0) {
        const lastItem = { ...items.at(-1) };
        lastItem.props = { ...lastItem.props, ...{ eventGridLastItem: true } };
        items.splice(-1, 1, lastItem);
    }

    return (
        <FlatList
            contentContainerStyle={collapsed ? {} : { width }}
            data={items}
            key={`grid-${collapsed ? 'col' : 'row'}-${id}`}
            keyExtractor={(item, index) => `Grid.Item.${nodeTypeAlias}.${item?.props.id}.${index}`}
            numColumns={collapsed ? 1 : 2}
            renderItem={({ item }) => <GridItem width={width}>{item}</GridItem>}
            style={collapsed ? { flex: 1 } : {}}
            dataSet={{ umbracoComponentName: nodeTypeAlias }}
        />
    );
};

const Styles = StyleSheet.create({
    itemContainer: {
        marginBottom: 0
    }
});

Grid.propTypes = {
    id: PropTypes.string,
    items: PropTypes.arrayOf(Object)
};
